import revive_payload_client_4sVQNw7RlN from "/home/forge/shop.ullmax.com/releases/81023597/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/home/forge/shop.ullmax.com/releases/81023597/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/home/forge/shop.ullmax.com/releases/81023597/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/home/forge/shop.ullmax.com/releases/81023597/node_modules/nuxt/dist/app/plugins/payload.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/home/forge/shop.ullmax.com/releases/81023597/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import plugin_vue3_A0OWXRrUgq from "/home/forge/shop.ullmax.com/releases/81023597/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/home/forge/shop.ullmax.com/releases/81023597/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/home/forge/shop.ullmax.com/releases/81023597/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_tbFNToZNim from "/home/forge/shop.ullmax.com/releases/81023597/node_modules/@zadigetvoltaire/nuxt-gtm/dist/runtime/plugin.mjs";
import fontawesome_a3gDgrBaWH from "/home/forge/shop.ullmax.com/releases/81023597/node_modules/@vesp/nuxt-fontawesome/dist/runtime/plugins/fontawesome.mjs";
import chunk_reload_client_UciE0i6zes from "/home/forge/shop.ullmax.com/releases/81023597/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import accessor_98O0LI8tOW from "/home/forge/shop.ullmax.com/releases/81023597/plugins/accessor.ts";
import adtraction_client_M8nv5J5nZZ from "/home/forge/shop.ullmax.com/releases/81023597/plugins/adtraction.client.ts";
import algolia_insights_client_TZbfLB2zaq from "/home/forge/shop.ullmax.com/releases/81023597/plugins/algolia-insights.client.ts";
import lang_Yip5L8Jphl from "/home/forge/shop.ullmax.com/releases/81023597/plugins/lang.ts";
import matomo_proxy_client_J5NFFEJTIM from "/home/forge/shop.ullmax.com/releases/81023597/plugins/matomo-proxy.client.ts";
import wishlist_client_fsbSLSe9ij from "/home/forge/shop.ullmax.com/releases/81023597/plugins/wishlist.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  check_outdated_build_client_8vK7RkfGxZ,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_tbFNToZNim,
  fontawesome_a3gDgrBaWH,
  chunk_reload_client_UciE0i6zes,
  accessor_98O0LI8tOW,
  adtraction_client_M8nv5J5nZZ,
  algolia_insights_client_TZbfLB2zaq,
  lang_Yip5L8Jphl,
  matomo_proxy_client_J5NFFEJTIM,
  wishlist_client_fsbSLSe9ij
]